export default __webpack_public_path__ + "static/media/contact-mail-link.a746b7da.svg";